import { createBrowserRouter, type RouteObject } from 'react-router';
import { LoadingScreen } from '@/components/common';
import { ROUTES } from '@/constants';
import { RouteError } from './error';
import { LandingPage } from './landing/page';
import { ReviewPage } from './review/page';
import { PatientPage } from './patient/page';

/**
 * The route tree.
 *
 * No guards, which is the whole shape of this portal: there is no session to
 * protect anything with, and the share token in the path is the only access
 * decision - made by the server on every request rather than by a component
 * here.
 */

/*
 * The local preview of the review screens, fed from a case on this machine.
 *
 * Behind `import.meta.env.DEV`, which Vite replaces with `false` in a
 * production build - the branch, the lazy imports behind it and the fixture
 * they load are all removed, so none of it reaches review.nudent.ai.
 */
const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      {
        path: ROUTES.demo,
        lazy: async () => ({ Component: (await import('./demo/page')).DemoReviewPage }),
        hydrateFallbackElement: <LoadingScreen />,
      },
      {
        path: ROUTES.demoPatient,
        lazy: async () => ({ Component: (await import('./demo/page')).DemoPatientPage }),
        hydrateFallbackElement: <LoadingScreen />,
      },
    ]
  : [];

export const router = createBrowserRouter([
  {
    errorElement: <RouteError />,
    children: [
      { path: ROUTES.home, element: <LandingPage /> },
      { path: ROUTES.reviewPattern, element: <ReviewPage /> },
      { path: ROUTES.patientPattern, element: <PatientPage /> },
      ...devRoutes,
      { path: '*', element: <RouteError /> },
    ],
  },
]);
